import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import vector from "../images/Vector.svg";
import qr from "../images/qr.webp";
import { Image } from "react-bootstrap";
import arrowright from "../images/arrowright.png";
import { motion } from "framer-motion";

const textVariants = {
  hidden: { x: -50, opacity: 0 }, 
  visible: { 
    x: 0, 
    opacity: 1, 
    transition: { duration: 0.5, ease: "easeOut" }
  }
};

const vectorVariants = {
  hidden: { x: -80, opacity: 0 }, 
  visible: { 
    x: 0, 
    opacity: 1, 
    transition: { duration: 0.7, ease: "easeOut", delay: 0.2 } 
  }
};
const zigZagVariants = {
  hidden: { x: 0, y: 0, opacity: 0 }, 
  visible: { 
    x: [0, -10, 10, -10, 0],
    y: [0, -5, 5, -5, 0],
    opacity: 1, 
    transition: { duration: 1.5, repeat: Infinity, ease: "easeInOut" }
  }
};

const firstParaVariants = {
  hidden: { x: -50, opacity: 0 },
  visible: { 
    x: 0, 
    opacity: 1, 
    transition: { duration: 0.6, ease: "easeOut" } 
  }
};

const secondParaVariants = {
  hidden: { x: 50, opacity: 0 },
  visible: { 
    x: 0, 
    opacity: 1, 
    transition: { duration: 0.6, ease: "easeOut", delay: 0.2 }
  }
};

const thirdParaVariants = {
  hidden: { y: 50, opacity: 0 },
  visible: { 
    y: 0, 
    opacity: 1, 
    transition: { duration: 0.6, ease: "easeOut", delay: 0.4 }
  }
};

const Worktogether = () => {
  return (
    <div>
  <section id="about" className="container-fluid1 work-together py-5">
      <div className="container">
        <div className="row align-items-center">
          
          
          <div className="col-md-7 text-md-end">
            <motion.h2 
              className="woto"
              variants={textVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }} 
            >
              Let’s work together
            </motion.h2>
            
            <motion.p 
              className="mb-3 need"
              variants={textVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
            >
              Need help with your next project?
            </motion.p>

            <motion.div 
              className="contact-info text-md-end d-flex gap-3 justify-content-center justify-content-md-end"
              variants={textVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
            >
              <a href="tel:+61481829998">+61 481 829 998</a>
              <a href="mailto:studio@edu360.com.au">studio@edu360.com.au</a>
            </motion.div>
          </div>

          
          <div className="col-md-5 d-flex align-items-center mt-4 mt-md-0">
            <motion.img 
              src={vector} 
              alt="Get in Touch Icon" 
              className="get-in-touch-icon me-3"
              variants={vectorVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
            />
             <a href="#" className="get-in-touch">
                <motion.span
                  variants={zigZagVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                >
                  GET IN TOUCH  
                </motion.span>
                
                <span className="arrow">
                  <motion.div
                    animate={{ opacity: [1, 0.5, 1], scale: [1, 1.2, 1] }}
                    transition={{ duration: 0.8, repeat: Infinity, ease: "easeInOut" }}
                    style={{ display: "inline-block" }}
                  >
                    <Image className="arrowstand" src={arrowright} alt="Mockup" fluid />
                  </motion.div>
                </span>
              </a>
          </div>

        </div>
      </div>
    </section>


   
   <section className="about-section">
      
      <img src={qr} alt="edu360 Mobile View" className="about-image d-none d-md-block" />

     
      <div className="about-content">
      <h2>About edu360</h2>

      <motion.p 
        variants={firstParaVariants} 
        initial="hidden" 
        whileInView="visible" 
        viewport={{ once: false, amount: 0.3 }}
      >
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed imperdiet magna nisi, acra massa rhoncus vel.
        Morbi pellentesque nisl a nibh blandit gravida. Interdum et malesuada fames ac ante ipsum primis in faucibus.
        Vestibulum vel varius sapien.
      </motion.p>

      <motion.p 
        variants={secondParaVariants} 
        initial="hidden" 
        whileInView="visible" 
        viewport={{ once: false, amount: 0.3 }}
      >
        Sed blandit consectetur turpis, sed ornare ipsum dapibus finibus. Nunc vel nibh ac mauris fringilla laoreet.
        Integer at interdum ante. Nullam non nunc in neque efficitur placerat et eget nulla.
      </motion.p>

      <motion.p 
        variants={thirdParaVariants} 
        initial="hidden" 
        whileInView="visible" 
        viewport={{ once: false, amount: 0.3 }}
      >
        Fusce eget pretium massa. Fusce quis justo sit amet leo placerat consequat. Aenean et turpis urna.
        Suspendisse nec elit a est tincidunt.
      </motion.p>

    </div>
    </section>

 </div>
  
  );
};

export default Worktogether;
